import { useEffect, useState } from "react";

const API = "https://pbplushservice.com/formapi.php";

// 🔹 Random father name
const randomFatherName = () => {
  const names = [
    "Ramesh Kumar",
    "Suresh Singh",
    "Mahesh Sharma",
    "Rajesh Verma",
    "Amit Gupta",
    "Sunil Patel",
    "Anil Yadav",
    "Vijay Mehta",
    "Prakash Mishra",
  ];
  return names[Math.floor(Math.random() * names.length)];
};

// 🔹 Random password
const generatePassword = (length = 8) => {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$!";
  return Array.from({ length }, () =>
    chars.charAt(Math.floor(Math.random() * chars.length))
  ).join("");
};

export default function UserForm() {
  const emptyForm = {
    name: "",
    dob: "",
    address: "",
    state: "",
    mobile: "",
    email: "",
    finance_bank: "",
    loan_amount: "",
  };

  const [form, setForm] = useState(emptyForm);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const submitForm = async (e) => {
    e.preventDefault();

    const payload = {
      ...form,
      fathername: randomFatherName(),     // ✅ auto
      password: generatePassword(),       // ✅ auto
    };

    console.log("Generated Password:", payload.password);

    await fetch(`${API}?action=create`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    setForm(emptyForm);
    alert("Application submitted successfully!");
  };

  return (
    <div
      style={{
        padding: "30px",
        backgroundColor: "white",
        maxWidth: "1000px",
        width: "90%",
        borderRadius: "10px",
        margin: "30px auto",
      }}
    >
      <h2 style={{ textAlign: "center" }}>Application Form</h2>

      <form
        onSubmit={submitForm}
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          justifyContent: "center",
        }}
      >
        {Object.keys(emptyForm).map((key) => (
          <div className="formlabeldiv" key={key}>
            <input
              type={
                key === "dob"
                  ? "date"
                  : key === "email"
                  ? "email"
                  : key === "loan_amount"
                  ? "number"
                  : "text"
              }
              name={key}
              value={form[key]}
              onChange={handleChange}
              required
            />
           <label>{   key === "dob"
                      ? "DATE"
                      : key.replaceAll("_", " ").toUpperCase()}</label>
          </div>
        ))}

        <button type="submit" style={{ maxWidth: "300px", width: "100%" }}>
          Submit
        </button>
      </form>
    </div>
  );
}
